export default "__VITE_ASSET__DfTzyQf7__"